export default {"src":"/_next/static/media/phone_lock.80423b28.svg","height":219,"width":352,"blurWidth":0,"blurHeight":0};